/** The roster page's one notice: what publishing the drafted cover did. */
import { Alert, Snackbar } from "@mui/material";
import React from "react";

import { SnackbarState } from "../controller/use-publish-drafts";

const RosterSnackbar: React.FC<{ state: SnackbarState; onClose: () => void }> = ({ state, onClose }) => (
	<Snackbar open={state.open} autoHideDuration={6000} onClose={onClose}>
		<Alert severity={state.severity} onClose={onClose}>
			{state.message}
		</Alert>
	</Snackbar>
);

export default RosterSnackbar;
